<script setup lang="ts">
  import { IconChevronDown } from '@gat-ship/icons'
  import {
    SelectScrollDownButton,
    type SelectScrollDownButtonProps,
    useForwardProps
  } from 'reka-ui'
  // fallow-ignore-next-line code-duplication
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<
    SelectScrollDownButtonProps & { class?: HTMLAttributes['class'] }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectScrollDownButton
    data-slot="select-scroll-down-button"
    v-bind="forwardedProps"
    :class="
      cn('flex cursor-default items-center justify-center py-1', props.class)
    "
  >
    <slot>
      <icon-chevron-down class="size-4" />
    </slot>
  </SelectScrollDownButton>
</template>
